import { useEffect } from "react";
import { useAuth } from "../context/auth";
import { Microsoft } from "@mui/icons-material";
import ZownIcon from "../assets/zown-logo-white-wide.svg";
import { Box, Paper, Typography, Button } from "@mui/material";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/login")({
  component: () => <LoginPage />
});

const LoginPage = () => {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate({ to: "/" });
    }
  }, [isAuthenticated, navigate]);

  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "background.default",
        p: 2
      }}
    >
      <Paper
        elevation={3}
        sx={{
          maxWidth: 400,
          width: "100%",
          p: 4,
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1
        }}
      >
        <img src={ZownIcon} alt="" style={{ width: "100px" }} />
        <Typography variant="h4" component="h1" gutterBottom textAlign="center">
          Welcome Back
        </Typography>
        <Typography variant="body1" gutterBottom textAlign="center">
          Please log in to continue
        </Typography>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={login}
          startIcon={<Microsoft />}
        >
          Log In
        </Button>
      </Paper>
    </Box>
  );
};
